import Switch from 'react-switch';
import AddressField from '../AddressField';

const SublocationDetail = ({ sublocation, locations = [], onChange, onAddressSelect }) => {
    if (!sublocation) return null;

    const toDatetimeLocal = (val) => {
        if (!val) return '';
        return val.slice(0, 16);
    };

    const field = (label, key, type = 'text') => (
        <div className="input-container">
            <div className="label">{label}:</div>
            <input
                className="input"
                type={type}
                value={sublocation[key] ?? ''}
                onChange={e => onChange(key, type === 'number'
                    ? (e.target.value === '' ? '' : parseFloat(e.target.value))
                    : e.target.value
                )}
            />
        </div>
    );

    const addressString = [sublocation.address1, sublocation.city, sublocation.state]
        .filter(Boolean)
        .join(', ');

    return (
        <div className="sublocation-detail-container">
            <h3>Sublocation Details</h3>
            <div className="detail-body">
                <div className="detail-left">
                    {field('Name', 'name')}

                    <div className="input-container">
                        <div className="label">Location:</div>
                        <select
                            className="input"
                            value={sublocation.locationId ?? ''}
                            onChange={e => onChange('locationId', e.target.value)}
                        >
                            <option value="">Select a location…</option>
                            {locations.map(loc => (
                                <option key={loc.id} value={loc.id}>
                                    {loc.name}{loc.address1 ? ` — ${loc.address1}` : ''}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="input-container">
                        <div className="label">Address:</div>
                        <AddressField
                            existingLocation={sublocation}
                            placeholder="Search for an address…"
                            editLocation={(loc) => onAddressSelect({
                                ...loc,
                                latitude: loc.latitude != null ? parseFloat(loc.latitude.toFixed(6)) : loc.latitude,
                                longitude: loc.longitude != null ? parseFloat(loc.longitude.toFixed(6)) : loc.longitude,
                            })}
                            searchValue={addressString}
                            setIsLocationEdited={() => onChange('address1', sublocation.address1)}
                        />
                    </div>

                    {field('Address 2', 'address2')}

                    {sublocation.address1 && (
                        <div className="address-confirmation">
                            <div className="confirm-row"><span className="confirm-label">City:</span> {sublocation.city}</div>
                            <div className="confirm-row"><span className="confirm-label">State:</span> {sublocation.state}</div>
                            <div className="confirm-row"><span className="confirm-label">Zip:</span> {sublocation.zip}</div>
                            <div className="confirm-row"><span className="confirm-label">Country:</span> {sublocation.country}</div>
                            <div className="confirm-row">
                                <span className="confirm-label">Lat / Lng:</span>
                                {sublocation.latitude}, {sublocation.longitude}
                            </div>
                            <div className="confirm-row"><span className="confirm-label">Timezone:</span> {sublocation.timezone}</div>
                        </div>
                    )}
                </div>

                <div className="detail-right">
                    <div className="input-container">
                        <div className="label">Is Preset:</div>
                        <Switch
                            checked={sublocation.isPreset ?? false}
                            onChange={val => onChange('isPreset', val)}
                            onColor="#2386EE"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={20}
                            width={45}
                        />
                    </div>
                    <div className="input-container">
                        <div className="label">Is Final:</div>
                        <Switch
                            checked={sublocation.isFinal ?? false}
                            onChange={val => onChange('isFinal', val)}
                            onColor="#2386EE"
                            uncheckedIcon={false}
                            checkedIcon={false}
                            height={20}
                            width={45}
                        />
                    </div>
                    <div className="input-container">
                        <div className="label">Available From:</div>
                        <input
                            className="input"
                            type="datetime-local"
                            value={toDatetimeLocal(sublocation.availableFrom)}
                            onChange={e => onChange('availableFrom', e.target.value)}
                        />
                    </div>
                    <div className="input-container">
                        <div className="label">Available To:</div>
                        <input
                            className="input"
                            type="datetime-local"
                            value={toDatetimeLocal(sublocation.availableTo)}
                            onChange={e => onChange('availableTo', e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SublocationDetail;
